import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Customer } from '../interfaces/customer.interface';
import { Filter } from '../interfaces/filter.interface';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {
  private baseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) { }

  listCustomers(pageNumber = 1, pageSize = 10, term = '', filters?: Filter[], orderBy?: string, isCachable = false): Observable<any> {
    const data = {
      term,
      advancedFilter: filters ?? [],
      pageNumber,
      pageSize,
      orderBy: orderBy ? [orderBy] : [],
    };

    const header = isCachable ? { headers: { 'X-Use-Cache': 'true' } } : {};
    return this.http.post(`${this.baseUrl}/Customer/List`, data, header).pipe(
      map((response: any) => response.data || response),
      catchError((error) => {
        console.error('Error fetching customers:', error);
        throw error;
      })
    );
  }

  getCustomer(id: number, isCachable = false): Observable<Customer> {
    const header = isCachable ? { headers: { 'X-Use-Cache': 'true' } } : {};
    return this.http.get(`${this.baseUrl}/Customer/${id}`, header).pipe(
      map((response: any) => response.data || response),
      catchError((error) => {
        console.error('Error fetching customer:', error);
        throw error;
      })
    );
  }

  createCustomer(data: Customer): Observable<Customer> {
    return this.http.post(`${this.baseUrl}/Customer`, data).pipe(
      map((response: any) => response.data || response),
      catchError((error) => {
        console.error('Error creating customer:', error);
        throw error;
      })
    );
  }

  getCustomerLookup(
    pageNumber = 1,
    pageSize = 50,
    term = '',
    advancedFilter: Filter[] = [],
  ): Observable<any> {
    return this.http.post(`${this.baseUrl}/Lookup/Customers`, {
      term,
      advancedFilter,
      includeDeleted: false,
      pageNumber,
      pageSize,
      orderBy: [],
      category: 'ALL',
    });
  }

  updateCustomer(data: Customer): Observable<Customer> {
    return this.http.put(`${this.baseUrl}/Customer`, data).pipe(
      map((response: any) => response.data || response),
      catchError((error) => {
        console.error('Error updating customer:', error);
        throw error;
      })
    );
  }

  deleteCustomer(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}/Customer/${id}`).pipe(
      map((response: any) => response.data || response),
      catchError((error) => {
        console.error('Error deleting customer:', error);
        throw error;
      })
    );
  }

  exportCustomers(payload: any): Observable<Blob> {
    return this.http.post(`${this.baseUrl}/Customer/export`, payload, { responseType: 'blob' }).pipe(
      catchError((error) => {
        console.error('Error exporting customers:', error);
        throw error;
      })
    );
  }
}
